import React from 'react';
import FlexHeaderCell from './FlexHeaderCell';
import FlexPassengerRow from './FlexPassengerRow';
import FlexOptionFooter from './flexOptionFooter';
import FlexOptionHeader from './FlexOptionHeader';

interface Props {
  isExpiredYet: boolean;
  flexName: string;
  flexPrices: any;
  flexPassengers: any;
  index: number;
}

const FlexOptionDetails: React.FC<Props> = ({ isExpiredYet, flexName, flexPrices, flexPassengers, index }) => {
  return (
    <>
      {index > 0 && <hr style={{ marginTop: 70 }} />}
      <FlexOptionHeader
        isExpiredYet={isExpiredYet}
        flexName={flexName}
        isRedeemed={flexPassengers?.passengers.every(passenger => passenger.valid === false)}
      />
      <FlexHeaderCell />
      {flexPassengers.passengers.map(passenger => (
        <FlexPassengerRow
          passenger={passenger.name}
          passengerType={passenger.type}
          productPrice={passenger.productPrice}
          referredPrice={passenger.referredPrice}
          refundPercentage={`${flexPassengers.productParameters.refundPercentage}%`}
          refundAmount={passenger.refundPrice}
          redemption={passenger.valid}
          key={passenger.paxId}
        />
      ))}
      <FlexOptionFooter flexData={flexPrices} />
    </>
  );
};

export default FlexOptionDetails;
